/* eslint-disable  no-underscore-dangle */

import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { helpers } from '@bingads-webui/deterministic-view';
import { Dialog } from '@bingads-webui/dialog';
import { dateFilterPlugin as newDateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { Hotel as hotelSchema } from '@bingads-webui/hotel-odata-schemas';
import InformationView from '../assignment-utils/Information-view';
import EditControl from '../assignment-utils/edit-control';
import HotelViewBase from '../assignment-utils/hotel-view-base';
import HotelsInGroupOptions from './grid-options';
import {
  HotelGroupModel, SubAccountModel, lightDismissible,
} from '../hotel-center-shared';
import { initializeFilterAgent } from '../assignment-utils/filter-agent';
import { getFilterConfig } from '../assignment-utils/filter-config';

const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');
const appConfig = globalContext.require('component/config/index');

lightDismissible();

/**
 * Class representing a navigation tabs for HotelsInGroupView
 * @extends View
 */
const errorCodeToStringMap = {
  CreateFailed: i18n.getString('HotelCenter_Group_Create_Failed_Generic_Error_Message'),
  RenameFailed: i18n.getString('HotelCenter_Group_Rename_Failed_Generic_Error_Message'),
  DeleteFailed: i18n.getString('HotelCenter_Group_Delete_Failed_Generic_Error_Message'),
  SameValueAlreadyExist: i18n.getString('HotelCenter_Group_Name_Exists_Error_Message'),
  GroupNotEmpty: i18n.getString('HotelCenter_Group_Not_Empty_Delete_Error_Message'),
  InternalError: i18n.getString('HotelCenter_Group_Delete_Failed_Generic_Error_Message'),
};

export default class HotelsInGroupView extends HotelViewBase {
  initialize({
    perfMarker,
    isUINext = false,
    preferenceStoreFactory,
    preferenceService,
    sessionStore,
  } = {}) {
    super.initialize();
    this.perfMarker = perfMarker;
    this.isUINext = isUINext;
    this.preferenceStoreFactory = preferenceStoreFactory;
    this.preferenceService = preferenceService;
    this.sessionStore = sessionStore;
    this.searchPropertyName = 'Name';

    const statusMessageBar = new InformationView({ name: 'messageView' });
    this.HotelGroupModel = HotelGroupModel; // for test mock

    statusMessageBar.setState({ statusMessage: '' });
    this.setChild('association-status-message', statusMessageBar);
  }

  get events() {
    return {
      'click .group-edit-menu': this.onGroupEditMenuClicked,
      'click .group-rename-menu': this.onGroupRenameMenuClicked,
      'click .group-delete-menu': this.onGroupDeleteMenuClicked,
    };
  }

  renderTrunk() {
    super.renderTrunk();

    if (this.gridFactory) {
      const gridOptions = new HotelsInGroupOptions({
        onSearchInvoked: searchTerm => this.onSearchInvoked(searchTerm),
        subAccountId: this.getState().subAccountId,
        hotelGroupId: this.getState().groupId,
        perfMarker: this.perfMarker,
        appConfig,
        isUINext: this.isUINext,
      });

      this.filterToolbar = gridOptions.filterToolbar;

      this.grid = this.gridFactory
        .use(newDateFilterPlugin)
        .use(perfMarkerPlugin)
        .create(gridOptions);

      super.gridCreated();

      this.grid.gridView.on('didSelect', (selected) => {
        this.trigger('selectionChanged', selected);
      });

      // Cross page selection should be reset after grid reload
      this.grid.gridView.on('didReload', () => {
        this.grid.gridView.deselectAll();
      });

      initializeFilterAgent({
        filterConfig: getFilterConfig({
          schema: hotelSchema,
          i18n,
          featureName: 'HotelInGroup',
          preferenceStoreFactory: this.preferenceStoreFactory,
          preferenceService: this.preferenceService && this.preferenceService.default,
          sessionStore: this.sessionStore,
        }),
        gridView: this.grid.gridView,
        tabView: this,
        toolbar: this.filterToolbar,
      });

      $('.hotel-in-group__container .grid-container').append(this.grid.gridView.render().el);
    }
  }

  setAssociationBarState(state) {
    this.getChild('association-status-message').setState(state);
  }

  onGroupEditMenuClicked(e) {
    // Since the event will bubble up to the light dismiss manager, it should specify
    // not to dismiss the target element
    if (e.originalEvent) {
      e.originalEvent.noDismiss = 'group-edit-menu-list'; // eslint-disable-line no-param-reassign
    }

    this._showPopup();
  }

  onGroupRenameMenuClicked() {
    this._hidePopup();

    const { isSubAccountSelected } = this.getState();
    const model = isSubAccountSelected ? this.getSubAccountModel() : this.getHotelGroupModel();
    const inputName = new EditControl({
      entity: model,
      field: 'Name',
      description: '',
    });
    const title = isSubAccountSelected ? i18n.getString('HotelCenter_SubAccount_Edit_Rename_Label_Format', this.getState().groupName) :
      i18n.getString('HotelCenter_Group_Edit_Rename_Label_Format', this.getState().groupName);

    model.errors.on('change:Name', (vm, error) => {
      if (_.isEmpty(error)) {
        $('.hotel-center-group-dialog-save').removeClass('disabled');
      } else {
        $('.hotel-center-group-dialog-save').addClass('disabled');
      }
    });

    this.showRenameDialog({
      title,
      inputName,
      model,
    });
  }

  getHotelGroupModel() {
    const entitySet = edm.currentAccount
      .SubAccounts.$withKey(this.getState().subAccountId.toString())
      .HotelGroups;

    return new HotelGroupModel({
      Id: this.getState().groupId,
      entitySet,
    });
  }

  getSubAccountModel() {
    const entitySet = edm.currentAccount.SubAccounts;

    return new SubAccountModel({
      Id: this.getState().subAccountId,
      entitySet,
    });
  }

  showRenameDialog({
    inputName,
    title,
    model,
  }) {
    const dialog = new Dialog({ className: 'hotel-center-group-dialog' }).setContent(inputName).setState({
      title,
      buttons: [{
        text: i18n.getString('HotelCenter_Group_Edit_Confirm_Label'),
        name: 'confirm',
        class: 'hotel-center-group-dialog-save',
      }, {
        text: i18n.getString('HotelCenter_Group_Edit_Cancel_Label'),
        name: 'cancel',
        class: 'dialog-cancel',
      }],
    });

    document.body.appendChild(dialog.el);
    dialog.show();

    $('.hotel-center-group-dialog-save').addClass('disabled');

    dialog.on('clickedButton', (name) => {
      if (name === 'confirm') {
        this._UpdateNameAsync(model).then(({ isSuccess, updatedName }) => {
          if (isSuccess) {
            helpers.updateView(this, { groupName: updatedName });
            this.trigger('selectionRenamed');

            dialog.remove();
          } else {
            $('.hotel-center-group-dialog-save').addClass('disabled');
          }
        });
      } else {
        dialog.remove();
      }
    });
  }

  onGroupDeleteMenuClicked() {
    this._hidePopup();

    const isUnDeletable = this.hotelCount && this.hotelCount > 0;
    const { isSubAccountSelected } = this.getState();
    const title = isSubAccountSelected ? i18n.getString('HotelCenter_SubAccount_Edit_Delete_Label_Format', this.getState().groupName) :
      i18n.getString('HotelCenter_Group_Edit_Delete_Label_Format', this.getState().groupName);
    const unDeletableDesc = isSubAccountSelected ? i18n.getString('HotelCenter_SubAccount_Not_Empty_Delete_Error_Message') : i18n.getString('HotelCenter_Group_Not_Empty_Delete_Error_Message');
    const inputContent = new EditControl({
      description: isUnDeletable ? unDeletableDesc : '',
    });

    this.showDeleteDialog({
      inputContent,
      title,
      isUnDeletable,
    });
  }

  showDeleteDialog({
    inputContent,
    title,
    isUnDeletable,
  }) {
    const dialog = new Dialog({ className: 'hotel-center-group-dialog' }).setContent(inputContent).setState({
      title,
      buttons: [{
        text: i18n.getString('HotelCenter_Group_Dialog_Confirm_Label'),
        name: 'confirm',
        class: `hotel-center-group-dialog-save${isUnDeletable ? ' disabled' : ''}`,
      }, {
        text: i18n.getString('HotelCenter_Group_Dialog_Cancel_Label'),
        name: 'cancel',
        class: 'dialog-cancel',
      }],
    });

    document.body.appendChild(dialog.el);
    dialog.show();

    dialog.on('clickedButton', (name) => {
      if (name === 'confirm') {
        this._deleteCurrentGroupAsync().then(({ isSuccess, errorCode }) => {
          if (isSuccess) {
            this.trigger('selectionDeleted');

            dialog.remove();
          } else {
            inputContent.setErrorMessage(errorCodeToStringMap[errorCode]);
            $('.hotel-center-group-dialog-save').addClass('disabled');
          }
        });
      } else {
        dialog.remove();
      }
    });
  }

  _UpdateNameAsync(model) {
    return model
      .save(['Name'], { patch: true })
      .then(() => {
        const updatedName = model.attributes.Name;

        return {
          isSuccess: true,
          updatedName,
        };
      })
      .catch((e) => {
        this.trigger('error', e);

        let errorCode = 'RenameFailed';

        if (e.body && e.body.value && e.body.value.length > 0) {
          errorCode = e.body.value[0].Code;
        }

        // Error is expecting an array to be set.
        model.errors.set('Name', [errorCodeToStringMap[errorCode]]);

        return {
          isSuccess: false,
          updatedName: '',
        };
      }).finally(() => {
        // TODO
      });
  }

  _deleteCurrentGroupAsync() {
    const { isSubAccountSelected } = this.getState();
    const modelToDelete = isSubAccountSelected ?
      this.getSubAccountModel() :
      this.getHotelGroupModel();

    return modelToDelete.destroy()
      .then(() => ({
        isSuccess: true,
      }))
      .catch((e) => {
        this.trigger('error', e);

        let errorCode = 'DeleteFailed';

        if (e.body && e.body.value && e.body.value.length > 0) {
          errorCode = e.body.value[0].Code;
        }

        return {
          isSuccess: false,
          errorCode,
        };
      }).finally(() => {
        // TODO
      });
  }

  _showPopup() {
    this.$('.light-dismissible').addClass('show');
    this.$('.light-dismissible').removeClass('hide');
  }

  _hidePopup() {
    this.$('.light-dismissible').addClass('hide');
    this.$('.light-dismissible').removeClass('show');
  }
}
